export const DAY_SIZE = 36;
export const DAY_MARGIN = 2;
export const DIALOG_WIDTH = 320;
export const VIEW_HEIGHT = 358;